import { render, staticRenderFns } from "./ItineraryDay.vue?vue&type=template&id=36e5101d&"
import script from "./ItineraryDay.vue?vue&type=script&lang=js&"
export * from "./ItineraryDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports